import React from 'react';
import noop from 'utils/noop';
import { StyledCoreUserMappingsDropdown, ReadOnlyLabel } from './CriteriaPropertyField.styled';

// type Props = {
//   disabled: boolean,
//   /** If the dropdown has an error. */
//   error: boolean,
//   /** Array comtaining the group index, query index and criteria property index. */
//   fieldIdentifier: [],
//   /** Callback function when field value is changed. */
//   onChange: () => {},
//   /** The options of the dropdown. */
//   options: [],
//   /** Placeholder text. */
//   placeholder: string,
//   /** The value of the field. */
//   value: string,
// };
export default class UserMappingsDropdown extends React.Component {
  static defaultProps = {
    disabled: false,
    error: false,
    fieldIdentifier: [],
    onChange: noop,
    options: [],
    placeholder: 'Select a Contact Property',
  };

  /**
   * Callback function when value changes.}
   */
  handleChange = (e, { value }) => {
    const { fieldIdentifier, onChange } = this.props;
    onChange(value, ...fieldIdentifier);
  };

  render() {
    const { error, options, placeholder, value, disabled } = this.props;
    return (
      <>
        <ReadOnlyLabel>{value}</ReadOnlyLabel>
        <StyledCoreUserMappingsDropdown
          data-test="collections-contact-property-dropdown"
          isError={error}
          fluid
          onChange={this.handleChange}
          options={options}
          placeholder={placeholder}
          search
          value={value}
          disabled={disabled}
        />
      </>
    );
  }
}
